import type { SiteContent } from '../../content/types';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

interface OpeningHoursCardProps {
  content: SiteContent;
}

export function OpeningHoursCard({ content }: OpeningHoursCardProps): JSX.Element {
  const title = content.hero.quickFacts.find((fact) => fact.label.toLowerCase().includes('öff'))?.label ?? content.contactPage.heroTitle;

  return (
    <Card className="bg-white">
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3 text-sm">
        {content.openingHours.days.map((day) => (
          <div key={day.day} className="flex items-start justify-between gap-3 border-b border-dashed border-[color:var(--color-border)] pb-2 last:border-0">
            <span className="font-semibold text-[color:var(--color-text)]">{day.day}</span>
            <span className="text-right text-[color:var(--color-muted)]">{day.slots.join(' · ')}</span>
          </div>
        ))}
        <p className="text-[color:var(--color-muted)]">{content.openingHours.note}</p>
      </CardContent>
    </Card>
  );
}
